<template lang="pug">
    tr

        // Program title
        td {{ item.title }}

        // Total meditations added to  program
        td {{ item.sessionCount }}

        // Actions
        td.text-xs-right(class="justify-center px-0 actions")

            // Edit business button
            button-component.edit(:action="edit" color="primary" icon="edit")

            // Delete business button
            button-component.delete(:action="remove" color="primary" icon="delete")
</template>

<script>
    import VueTypes from 'vue-types';
    import ButtonIcon from '~components/ButtonIcon';
    import { mapActions } from 'vuex';

    export default {
        components: {
            ButtonComponent: ButtonIcon
        },
        props: {
            item: VueTypes.object.def({})
        },
        methods: {
            ...mapActions('programs', ['deleteProgram']),

            /**
             * Edit program
             */
            edit() {
                this.$router
                    .push({
                        name: 'dashboard.programs.edit',
                        params: { id: this.item.id }
                    })
                    .catch(() => {});
            },

            /**
             * Delete program.
             * @returns {Promise<void>}
             */
            async remove() {
                const resp = await this.deleteProgram(this.item.id);

                if (resp) {
                    this.$emit('removed', this.item.id);
                }
            }
        }
    };
</script>
